import { Button, ButtonLink } from "@/components/Buttons/index";
import routes from "@/lib/routes";
import { useRouter } from "next/router";
import loginStyles from "@/styles/Login.module.scss";
import processStyles from "@/styles/Process.module.scss";
import { useModal } from "@/hooks";
import IdcCooperationSignUpModal from "../IdcCooperationSignupModal";
import { useCallback } from "react";

// ログイン画面3
export default function SpooxCooperationForm(props) {
  const router = useRouter();
  const { showModal, hideModal } = useModal();
  const onClickHandle = useCallback(() => {
    hideModal();
    router.push(routes.signUp);
  }, []);
  const showSignupModal = useCallback(() => {
    showModal(<IdcCooperationSignUpModal onClickHandle={onClickHandle} />, {
      closeButton: true,
      outerAreaClose: true,
      style: "signup",
    });
  }, [onClickHandle]);
  return (
    <div className={`${processStyles.content} ${loginStyles.loginSet}`}>
      <div className={`${loginStyles.loginSection} ${loginStyles.formSection}`}>
        <h3 className={loginStyles.sectionTitle}>SPOOX IDをお持ちの方</h3>
        <div className={loginStyles.sectionInner}>
          <div className={loginStyles.loginBtnArea}>
            <ButtonLink
              href={routes.loginspoox}
              fillMainColor
              large
              fontFixed
              fontBold
              disabled={props.error}
            >
              SPOOX IDとスカパー！メンバーズIDを連携
            </ButtonLink>
          </div>
          <div className={loginStyles.caption}>
            ※現在ご契約中の商品及び登録済み支払方法の継続利用には、
            <br />
            SPOOX IDとスカパー！メンバーズIDの連携が必要です。
            <br />
            必ず連携させてください。
          </div>
        </div>
      </div>
      <div className={`${loginStyles.loginSection} ${loginStyles.formSection}`}>
        <h3 className={loginStyles.sectionTitle}>
          SPOOXを初めてご利用される方
        </h3>
        <div className={loginStyles.sectionInner}>
          <p>
            <Button
              onClick={showSignupModal}
              fillMainColor
              large
              fontFixed
              fontBold
              disabled={props.error}
            >
              SPOOX利用登録
            </Button>
          </p>
        </div>
      </div>
    </div>
  );
}
